module.exports = __webpack_public_path__ + "static/img/unoLogo.87017a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/unoLogo.png
// module id = 5u05
// module chunks = 1